import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { OrgSwitcherService } from "./org-switcher.service";

export const orgSwitcherGuard: CanActivateFn = async () => {
    const orgSwitcherService = inject(OrgSwitcherService);
    await orgSwitcherService.completeAfterSignIn();

    return !orgSwitcherService.redirectingToSignIn;
};
